/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type AlertStatuses = typeof AlertStatuses[keyof typeof AlertStatuses];


export const AlertStatuses = {
  Active: 'Active',
  Dismissed: 'Dismissed',
  Resolved: 'Resolved',
  Archived: 'Archived',
} as const;
